import { render } from "./optionsMore.vue?vue&type=template&id=c8f88fdc"
import script from "./optionsMore.vue?vue&type=script&lang=js"
export * from "./optionsMore.vue?vue&type=script&lang=js"

import "./optionsMore.vue?vue&type=style&index=0&id=c8f88fdc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__